module.exports = __webpack_public_path__ + "static/media/curve-mobile.797cd6dc.png";